import { Component, OnInit } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { CommonService } from '@app/shared/services/common/common.service';
import { ReportService } from '@app/shared/services/reports/report.service';
import { AngularCsv } from 'angular7-csv';
import { ErrorhandlerService } from '@app/shared/services/errorhandler/errorhandler.service';
@Component({
  selector: 'app-order-sales-report',
  templateUrl: './order-sales-report.component.html',
  styleUrls: ['./order-sales-report.component.css']
})
export class OrderSalesReportComponent implements OnInit {
 // For Infinite scroll of grid
  initialItemsCount !: number;  // No of items to skip
  storeList !: any[];
  reportList: any[] = [];
  ApplicationUserId !: any;
  minDate = new Date(2018, 0, 1);
  storeadminreportingForm: FormGroup;
  isGenerateExcel = false;
  constructor(private formBuilder: FormBuilder, private commonService: CommonService, private reportService: ReportService,
    private loader: LoaderService, private errorhandlerService: ErrorhandlerService,
    private notificationService: NotificationService) {
    this.storeadminreportingForm = this.formBuilder.group({
      StoreId: new FormControl(''),
      UserId: localStorage.getItem('userId'),
      StatusId: new FormControl(''),
      FromDate: new FormControl(''),
      ToDate: new FormControl(''),
      SkipNoOfRecord: 0,
      TakeNoRecord: 10,
      });
  }

  ngOnInit() {
    this.storeList = [];
    this.initialItemsCount = 0;
    this.ApplicationUserId = localStorage.getItem('userId');
    this.fn_getStoreList();
  }

  /** Function to get store list */
  fn_getStoreList() {
    this.loader.show();
    this.commonService.getStoreListDashboard('', 0, 0, false, this.ApplicationUserId,false).subscribe((res: any) => {
      if (res.StatusCode === 200) {
        this.storeList = res.Data.ResponseData;
        this.storeadminreportingForm.patchValue({
          StoreId: this.storeList[0].StoreId,
        });
        this.loader.hide();
      } else if (res.StatusCode === 204 || res.StatusCode === 404) {
        this.storeList = [];
        this.loader.hide();
      }
    }, err => {
      this.loader.hide();
      this.errorhandlerService.handleError(err);
    });
  }

  /** Function to add new lazy loaded items to original items list */
  fn_AddLazyLoadedItems(items: any) {
    if (items !== null && items.length !== 0) {
        for (let i = 0; i < items.length; i++) {
          if (!this.reportList.find(x => x.OrderNumber === items[i].OrderNumber)) {
            this.initialItemsCount = this.reportList.push(items[i]);
          }
        }
    }
    if (this.initialItemsCount > 0) {
      this.isGenerateExcel = true;
    } else {
      this.isGenerateExcel = false;
      this.notificationService.info('No matching record(s) found', 'Record');
    }
  }

  /** Fucn to update the order status */
  fn_selectedStore(event: any) {
    this.storeadminreportingForm.patchValue({
      StoreId: event,
    });
  }

  fn_selectedOrder(event: any) {
    this.storeadminreportingForm.patchValue({
      StatusId: event,
    });
  }

  FromDateEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    this.storeadminreportingForm.patchValue({
      FromDate: event.value,
    });
    this.minDate = new Date(this.storeadminreportingForm.controls.FromDate.value);
  }

  ToDateEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    this.storeadminreportingForm.patchValue({
      ToDate: event.value,
    });
  }

  fn_getSaleOrderReport(form: FormGroup, callType: string) {
    if (this.ApplicationUserId) {
      return;
    }
    if (callType === 'form') {
      this.initialItemsCount = 0;
      this.storeadminreportingForm.patchValue({
        SkipNoOfRecord: this.initialItemsCount,
        TakeNoRecord: 10
        });
        this.reportList = [];
    }
    if (callType === 'scroll' &&  this.initialItemsCount === 0) {
      return;
    }
    form.value.FromDate = (form.value.FromDate !== null && form.value.FromDate !== '')
      ? form.value.FromDate.toUTCString() : '';
    form.value.ToDate = (form.value.ToDate !== null && form.value.ToDate !== '')
      ? form.value.ToDate.toUTCString() : '';
      this.storeadminreportingForm.patchValue({
      SkipNoOfRecord: this.initialItemsCount,
      TakeNoRecord: 10
      });
    this.loader.lazyLoaderShow();
    this.reportService.getOrderSalesReport(form.value).subscribe((res: any) => {
      if (res.StatusCode === 200) {
        this.fn_AddLazyLoadedItems(res.Data.ResponseData);
        this.loader.lazyLoaderHide();
      } else if (res.StatusCode === 400) {
        this.notificationService.error('Something went wrong', 'Try again');
      } else if (res.StatusCode === 500) {
        this.notificationService.error('An error occured', 'Try again');
      }
      this.loader.lazyLoaderHide();
    }, (err: any) => {
      // this.notificationService.error('An error occured', 'Error');
      this.errorhandlerService.handleError(err);
      this.loader.lazyLoaderHide();
    });
  }

  fn_DownloadSaleOrderReport() {
    const options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      showTitle: false,
      useBom: true,
      noDownload: false,
      headers: ['Order No', 'Order Date', 'Status', 'Payment Method', 'Username', 'Address', 'Quantity', 'Order Amount', 'StoreName']
    };

    // tslint:disable-next-line:no-unused-expression
    new AngularCsv(this.reportList, 'OrderSalesReport', options);
  }

}
